// components/ApplicationCard.js
import React, { useState, useEffect, useContext } from 'react';
import styles from './ApplicationCard.module.css';
import CharcodePill from '../CharcodePill.js';
import selectArrowGrey from '../../assets/images/selectArrowGrey.png';
import helpers from '../../helpers.js';
import { UserContext } from '../../UserContext';

const ApplicationCard = (props) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [bagDetails, setBagDetails] = useState({});
  const { user } = useContext(UserContext);

  // Fetch bag details when expanded
  useEffect(() => {
    if (isExpanded && props.app?.bagIds && props.app.bagIds.length > 0) {
      const fetchBagDetails = async () => {
        const details = {};
        
        for (const bagId of props.app.bagIds) {
          try {
            const request = {
              method: "get",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: "Bearer " + user.token,
              }
            };
            
            const response = await fetch(user.backEndURL + "/bag/info/" + bagId, request);
            const jsonResponse = await response.json();
            
            if (jsonResponse.success && jsonResponse.data?.bagInfo) {
              details[bagId] = jsonResponse.data.bagInfo;
            }
          } catch (err) {
            console.error(`Failed to fetch bag ${bagId}:`, err);
          }
        }
        
        setBagDetails(details);
      };
      
      fetchBagDetails();
    }
  }, [isExpanded, props.app?.bagIds, user.token, user.backEndURL]);

  if (props.isPlaceholder) {
    return (
      <div className={`${styles.applicationCard} ${styles.placeholderCard}`}>
        <div className={styles.applicationHeader}>
          <div className={styles.placeholderText}>No data to be displayed ...</div>
          <div className={styles.placeholderPillsWrapper}>
            <div className={styles.placeholderPill}></div>
            <div className={styles.placeholderPill}></div>
            <div className={styles.placeholderPill}></div>
            <div className={`${styles.placeholderPill} ${styles.placeholderPillWide}`}></div>
          </div>
        </div>
        <div className={styles.placeholderFooter}>
          <span className={styles.placeholderIcon}>cow </span>
        </div>
      </div>
    );
  }

  const { app } = props;

  return (
    <div className={styles.applicationCard}>
      <div 
        className={styles.applicationHeader}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div className={styles.applicationId}>{app.id}</div>
        <div className={styles.dateIcon}>
          <span className={styles.icon}>calendar-alt</span>
          <span className={styles.dateText}>{app.date}</span>
        </div>
        <div className={styles.productInfo}>
          <span className={styles.icon}>shopping-bag</span>
          <span className={styles.productText}>{app.quantity} × {app.productType}</span>
        </div>
        <div className={styles.weightInfo}>
          <span className={styles.icon}>balance-scale</span>
          <span className={styles.weightText}>{app.weight} kg</span>
        </div>
        <div className={styles.deliveryMethod}>{app.deliveryMethod}</div>
        <img 
          src={selectArrowGrey} 
          alt="expand" 
          className={`${styles.expandIcon} ${isExpanded ? styles.expanded : ''}`}
        />
      </div>

      {isExpanded && (
        <div className={styles.expandedContent}>
          {app.targetedZones && app.targetedZones.length > 0 && (
            <div className={helpers.clx(styles.section, styles.targetedZonesSection)}>
              <div className={styles.sectionTitle}>Targeted Zones*:</div>
              <div className={styles.zonePills}>
                {app.targetedZones.map((zone, i) => (
                  <span key={i} className={styles.zonePill}>{zone}</span>
                ))}
              </div>
            </div>
          )}

          {app.bagIds && app.bagIds.length > 0 && (
            <div className={styles.section}>
              <div className={styles.sectionTitle}>Bag IDs</div>
              <div className={styles.bagPills}>
                {app.bagIds.map((bagId, i) => (
                  <CharcodePill 
                    key={i} 
                    charcodeId={bagId} 
                    bagInfo={bagDetails[bagId]}
                  />
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

ApplicationCard.defaultProps = {
  isPlaceholder: false,
  app: {
    id: "A-001",
    date: "13-02-2025",
    quantity: 3,
    productType: "PelletChar",
    weight: 650.8,
    deliveryMethod: "Direct-to-Land",
    targetedZones: [],
    bagIds: []
  }
};

export default ApplicationCard;